import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Registration } from "../../../../../../models/registration";
import { DeterminantService } from "../../../../../../services/registration-controller/determinant.service";
import { Store } from "../../../../../../services/store.service";

@Component({
  selector: "cost-determinant-section",
  templateUrl: "./cost-determinant-section.component.html",
})
export class CostDeterminantSection implements OnInit, OnDestroy {

  @Input() public serviceId: string = this.store.state.common.serviceId;
  @Output() public onCancel = new EventEmitter();
  public jsonString: string;
  public selectedIndex: number;
  public registration: Registration;
  public type: string;
  public selectedDeterminant: any;
  public listToggle: boolean = false;
  public sectionTitle: string = "";
    public subscription: any;

  constructor(public store: Store,
              public determinantService: DeterminantService) {
  }

  public ngOnInit() {
    this.subscription = this.determinantService.changeCost.subscribe((data) => {
      this.selectedIndex = data.selectedIndex;
      this.jsonString = data.jsonString;
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public closeLayer() {
    this.store.state.common.determinantSection.reset();
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public setListView(b: boolean) {
    this.listToggle = b;
  }

  public onSave(jsonString: any) {
    this.jsonString = jsonString;
    this.determinantService.jsonString = jsonString;
    this.determinantService.selectedIndex = this.selectedIndex;
    this.determinantService.initCostDeterminant();
    this.closeLayer();
  }
}
